if not App.angularApp?
    return

###
 * mf-phone-format
 *
 * takes string, strips non-numeric and formats string into "(999) 999-9999"
 *
###
App.angularApp.filter 'mfPhoneFormat', () ->
    return (input) ->
        if not input or input.match /[a-zA-Z]/
            return input

        input = input.replace(/\D/g, '')
        return input.replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3')
